import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

export default function ChangeRole() {
  let isAdmin = useSelector((state) => state.admin.value);
  const accessToken = sessionStorage.getItem('accessToken');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;

  const getUsers = () => {
    axios
      .get(`${apiUrl}/auth`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'Accept': '*/*'
        }
      })
      .then((response) => {
        const sortedUsers = response.data.sort((a, b) =>
          a.username.localeCompare(b.username)
        );
        setUsers(sortedUsers);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleClickOpen = (name, role) => {
    setSelectedUser(name);
    setSelectedRole(role);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirmUser = () => {
    axios
      .post(
        `${apiUrl}/auth`,
        { username: selectedUser, groupName: selectedRole }
        ,{
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'Accept': '*/*'
          }
        }
      )
      .then((resp) => {
        handleClose();
        getUsers();
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <Box
      sx={{
        marginLeft: "180px",
        padding: 2,
        backgroundColor: "#EEEEEE",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {isAdmin ? (
        loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <TableContainer
            component={Paper}
            sx={{maxWidth: 1500,
              width: "100%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
              borderRadius: "12px",
              overflow: "hidden"}}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#00ADB5" }}>
                  <TableCell
                    sx={{
                      fontSize: "0.9rem",
                      padding: "10px",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography sx={{fontFamily:"Poppins"}} variant="h6">Username</Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "0.9rem",
                      padding: "10px",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                    }}
                  >
                    <Typography sx={{fontFamily:"Poppins"}} variant="h6">Role</Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "0.9rem",
                      padding: "10px",
                      color: "#FFFFFF",
                      fontWeight: "bold",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((ele, i) => (
                  <TableRow
                    key={i}
                    sx={{
                      backgroundColor: i % 2 === 0 ? "#FFFFFF" : "#F7F7F7",
                      "&:hover": {
                        backgroundColor: "#E0F7FA",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        padding: "10px",
                        fontSize: "0.9rem",
                        color: "#222831",
                        height: "40px",
                        fontFamily:"Poppins"
                      }}
                    >
                      {ele.username}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "10px",
                        fontSize: "0.9rem",
                        color: "#222831",
                        height: "40px",
                        fontFamily:"Poppins"
                      }}
                    >
                      {ele.groups.length !== 0 ? ele.groups.join(", ") : "new"}
                    </TableCell>
                    <TableCell sx={{ padding: "10px", height: "40px" }}>
                      {ele.groups.length === 0 ? (
                        <Box>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#00ADB5",
                              color: "#FFFFFF",
                              marginRight: 1,
                              fontFamily:"Poppins",
                              "&:hover": {
                                backgroundColor: "#007B7F",
                              },
                            }}
                            onClick={() =>
                              handleClickOpen(ele.username, "admin")
                            }
                          >
                            <AdminPanelSettingsIcon/>
                            Assign Admin Role
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#393E46",
                              color: "#FFFFFF",
                              fontFamily:"Poppins",
                              "&:hover": {
                                backgroundColor: "#222831",
                              },
                            }}
                            onClick={() =>
                              handleClickOpen(ele.username, "member")
                            }
                          >
                            <PersonIcon/>
                            Assign Member Role
                          </Button>
                        </Box>
                      ) : ele.groups.includes("member") &&
                        !ele.groups.includes("admin") ? (
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#00ADB5",
                            color: "#FFFFFF",
                            fontFamily:"Poppins",
                            "&:hover": {
                              backgroundColor: "#007B7F",
                            },
                          }}
                          onClick={() => handleClickOpen(ele.username, "admin")}
                        >
                          <AdminPanelSettingsIcon/>
                          Assign Admin Role
                        </Button>
                      ) : (
                        <Typography variant="body2" sx={{ color: "#222831" ,fontFamily:"Poppins",}}>
                          Already {ele.groups.join(" and ")}
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      ) : (
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <Typography variant="h5" sx={{ color: "red", fontWeight: "bold",fontFamily:"Poppins", }}>
            You are not authorized to view this page. Ask Admin to provide
            access.
          </Typography>
        </Box>
      )}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: "#222831",fontFamily:"Poppins", }}>Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "#222831" ,fontFamily:"Poppins",}}>
            Are you sure you want to assign the role of{" "}
            <strong>{selectedRole}</strong> to <strong>{selectedUser}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  onClick={handleClose} sx={{ color: "#00ADB5",fontFamily:"Poppins" }}>
            Cancel
          </Button>
          <Button onClick={confirmUser} sx={{ color: "#00ADB5" ,fontFamily:"Poppins"}}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
